import { useContext } from 'react';

import { SuperSearchDropdownContext } from './SuperSearchDropdownContext';

const useSuperSearchDropdownContext = () => useContext(SuperSearchDropdownContext);

export default useSuperSearchDropdownContext;
